var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"profile-image",attrs:{"src":require("@/assets/profile.jpg")}})])
}]

export { render, staticRenderFns }